'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import { useState } from 'react';
import { Card, CardBody, CardTitle, Col, Container, Row } from 'reactstrap';
import GeneralContactForm from 'shared/components/GeneralContactForm';
import AppLayout from '../../../components/AppLayout';
import { Dictionaries, Locale } from 'shared/i18n/i18n-config';
import { getI18nUtils } from 'shared/i18n/i18n-utils';

const confirmationMessage = 'general-contact-form-thanks';

type Props = {
  dictionary: Partial<Dictionaries>;
  locale: Locale;
};
export default function ContactPage({ dictionary, locale }: Props) {
  const [submitting, setSubmitting] = useState<boolean>(false);
  const { formatMessage } = getI18nUtils(dictionary);
  return (
    <AppLayout
      dictionary={dictionary}
      id="happyAtSynergiePage"
      availableLocales={[
        { locale: 'nl', pathname: `/contact/` },
        { locale: 'fr', pathname: `/contact/` },
      ]}
      pageHeader={{
        backgroundUrl: '/headers/header_happy.jpg',
        backgroundUrlMobile: '/headers/header_happy_mobile.jpg',
        type: 'fullWidthImg',
      }}
    >
      <Container className="my-5 pb-3">
        <Row>
          <Col lg={{ size: 10, offset: 1 }}>
            <Card id="generalContactForm" className={`mt-4${submitting ? ' submitting' : ''}`}>
              <CardBody>
                <CardTitle tag="h2" className="mb-4">
                  {formatMessage({ id: 'contact-form-contact-us' })}
                </CardTitle>
                <GeneralContactForm
                  locale={locale}
                  dictionary={dictionary}
                  landscape
                  cvUpload
                  submitHandler={setSubmitting}
                  submitting={submitting}
                  confirmationMessage={confirmationMessage}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </AppLayout>
  );
}
